import { del } from './requests'

export function deleteAccount () {
  return del('account')
}
